import { memo, type ReactNode } from 'react';
import { Flex } from '@chakra-ui/react';

import { PLAN_CHART_CARD_RADIUS, neutral } from '../planPageRevampUi';

interface Properties {
  children: ReactNode;
  flex?: string;
  minH?: number | string;
  h?: number | string;
  overflow?: 'hidden' | 'auto' | 'visible';
  borderRadius?: string;
}

/**
 * The card shell used by the chart card and the table card (Figma 76685:6566
 * / 76685:5630) — white surface, one `neutral.border` hairline, 12px radius.
 * Same spec as DimensionsRevamp's grid wrapper (`NewTable.tsx`: `neutral.surface`
 * fill, `neutral.border`, `radius.surface`), kept here as its own component
 * (was inlined as `PlanAnalyticsCard` in `PlanPageContent.tsx`) so the KPI
 * cards, chart card and table card can't drift onto three different card specs.
 */
const PlanCard = memo(
  ({
    children,
    flex = '1 1 0',
    minH = 0,
    h,
    overflow = 'hidden',
    borderRadius = PLAN_CHART_CARD_RADIUS,
  }: Properties) => (
    <Flex
      direction='column'
      flex={flex}
      minW={0}
      minH={minH}
      h={h}
      bg={neutral.surface}
      border='1px solid'
      borderColor={neutral.border}
      borderRadius={borderRadius}
      overflow={overflow}
      position='relative'
    >
      {children}
    </Flex>
  ),
);

PlanCard.displayName = 'PlanCard';

export default PlanCard;
